import { h } from 'preact';
import { useStyles } from '../../../../common/hooks';
import Position from '../../../../common/utils/Position';
import {
  PLAYBACK_CENTERED_WRAPPER_STYLE,
  PLAYBACK_DEFAULT_WRAPPER_STYLE,
  PLAYBACK_HIDDEN
} from './styles';

function PlaybackWrapper({
  children,
  centered,
  styles = {},
  hidden
}) {
  const visibleButtons = children.filter((child) => !child.props.hidden);
  const setStyles = useStyles();
  return (
    <div
      style={{
        ...(centered ? PLAYBACK_CENTERED_WRAPPER_STYLE : setStyles(PLAYBACK_DEFAULT_WRAPPER_STYLE)),
        ...(hidden ? PLAYBACK_HIDDEN : {}),
        ...styles
      }}
    >
      <Position disableFirstProp={centered} disableLastProp>
        {visibleButtons}
      </Position>
    </div>
  );
}

export default PlaybackWrapper;
